import Vue from 'vue'
import Vuex from 'vuex'

import qs from 'qs'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        queryData: null,
        readNum: 0,
        daibanCount: {
            authCount: 0,
            deliverCount1: 0,
            deliverCount2: 0,
            attendanceCount: 0
        },
        avatar: '',
        refresh: false, // websocket 刷新页面数据
        shoujiData: {
            labelzhiye: [],
            label1: '',
            label2: '',
            labelId1: '',
            labelId2: '',

            labelId3: [],
            labelId3Add: [],
            label3: [],
            label3Add: [],

            labelShijian: [],
            labelShijianAdd: [],

            labelShuliangdu: [],
            labelShuliangduAdd: [],

            label3S: [],
            labelId3S: [],
            labelShijianS: [],
            labelShuliangduS: [],

            hangyelingyuId: [],
            hangyelingyuId2: [],
            hangyelingyu: [],
            hangyelingyu2: [],
            hangyelingyuNianxian: [],

            salaryWork: '',
            salaryExpect: '',
            intro: '',

            jobWay: 0,

            avatar: '',

            yuancheng: '',

            jiaoyubeijing: [],
            xiangmujingli: [],
            gongzuojingli: []
        },
        userData: {},

        jobStatus: false,
        isShowBack: true, //认证结果页返回到待测试页面，页面是否需要展示返回按钮

        jianliType: 1, //1为手动填写，2为上传简历
        jianliFrom: 2, //1为/perfectInfo3，2为别的页面路由

        dialogVisible: false, //展示岗位意向弹窗
        guanjiaEWMShow: false,

        //2023/10/18新版认证流程收集数据
        userInfoData: {
            avatar: '',
            intro: '',
            resume: '',
            workYear: 1,
            hangyelingyu: [],
            hangyelingyuId: [],
            hangyelingyu2: [],
            hangyelingyuId2: [],

            labelId3: [],
            label3: [],
            label2: '',
            labelId2: '',
            label1: '',
            labelId1: '',
            labelShuliangdu: [],

            jiaoyubeijing: [],
            xiangmujingli: [],
            gongzuojingli: [],

            name: '',
            gender: '',
            birthday: ''
        },

        wstk: ''
    },
    actions: {
        unreadCount(context) {

            console.log(context, 'context')

            window.fdGlobal.ajax({
                method: 'POST',
                url: window.fdConfig.url.common('getMessageCount'),
                // URL参数
                // 必须是一个纯对象或者 URL参数对象
                headers: { 'content-type': 'application/x-www-form-urlencoded', type: 'reward' },
                data: qs.stringify({}),
                //params: '',
                // 默认值是json
                responseType: 'json'
            }).then((data) => {
                if (data.data.code == 1) {
                    // context.commit("add",data.data.data)
                    context.state.daibanCount = {
                        authCount: data.data.authCount,
                        deliverCount1: data.data.deliverCount1,
                        deliverCount2: data.data.deliverCount2,
                        attendanceCount: data.data.attendanceCount
                    }
                    console.log(context, 'context2')
                        //this.daibanCount = data.data.data

                } else {
                    this.$message.error(data.data.message);
                }
            }, (data) => {
                this.$message.error(data.data.message);
            });
        },


    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js